/** @griffel:css-start [d] null **/
.f1qcbe8p{min-height:100dvh;}
.f1ewtqcl{box-sizing:border-box;}
/** @griffel:css-end **/
/** @griffel:css-start [d] {"p":-1} **/
.fg89v1a{padding-block:var(--spacingVerticalXXL);}
.fjshy37{padding-inline:var(--spacingHorizontalL);}
/** @griffel:css-end **/
/** @griffel:css-start [d] null **/
.fxugw4r{background-color:var(--colorNeutralBackground1);}
.f19n0e5{color:var(--colorNeutralForeground1);}
.f1wm5lqa{max-width:880px;}
/** @griffel:css-end **/
/** @griffel:css-start [d] {"p":-1} **/
.f1o88i5s{margin-inline:auto;}
/** @griffel:css-end **/
/** @griffel:css-start [d] null **/
.f22iagw{display:flex;}
.f1vx9l62{flex-direction:column;}
.f13377fj{row-gap:var(--spacingVerticalL);}
.fjgzulp{align-self:flex-start;}
/** @griffel:css-end **/